// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- RxJs
import { BehaviorSubject, Observable, Subject } from 'rxjs';

// --- HS Code
import { RespondentDeclineStages, TokenValidationErrorTypes } from '../../../models';
import { Router } from '@angular/router';

// #endregion

@Injectable({
  providedIn: 'root'
})
export abstract class RespondentDeclineBaseService {

  protected _declineStage$: BehaviorSubject<RespondentDeclineStages>;
  get declineStage$(): Observable<RespondentDeclineStages> {
    return this._declineStage$;
  }

  protected _fullName$: BehaviorSubject<string>;
  get fullName$(): Observable<string> {
    return this._fullName$;
  }

  protected _tokenValidation$: BehaviorSubject<TokenValidationErrorTypes>;
  get tokenValidation$(): Observable<TokenValidationErrorTypes> {
    return this._tokenValidation$;
  }

  protected _emailAddress$: BehaviorSubject<string>;
  get emailAddress$(): Observable<string> {
    return this._emailAddress$;
  }

  protected _tokenResolved$: Subject<boolean>;
  get tokenResolved$(): Observable<boolean> {
    return this._tokenResolved$;
  }

  constructor(protected router: Router) {
    this._declineStage$ = new BehaviorSubject<RespondentDeclineStages>(RespondentDeclineStages.confirm);
    this._tokenValidation$ = new BehaviorSubject<TokenValidationErrorTypes>(TokenValidationErrorTypes.noError);
    this._emailAddress$ = new BehaviorSubject('');
    this._fullName$ = new BehaviorSubject('');
    this._tokenResolved$ = new Subject();
  }

  undo(): void {
    this._declineStage$.next(RespondentDeclineStages.confirm);
  }

  cancel(token: string): void {
    this.router.navigate(['/endpoints/respondent', token]);
  }

  abstract resolveToken(token: string): void;
  abstract decline(token: string): void;
}
